import React from 'react';
import styled from 'styled-components';

import { RewardsRibbon } from 'shared/assets/rewards-ribbon';
import { Button } from 'src/components/core';
import { Statuses } from 'src/components/loyalty/use-loyalty';

type ConnectProps = {
  setStatus: (status: Statuses) => void;
  programName: string;
  programDescription: string;
};

export const Connect = ({ setStatus, programName, programDescription }: ConnectProps): JSX.Element => {
  const handleConnect = (): void => {
    setStatus(Statuses.terms);
  };

  return (
    <Container data-testid='loyalty-connect'>
      <StyledRewardsRibbon height={52} width={52} />

      <ContentContainer>
        <div>
          <Heading>Connect To {programName}</Heading>
          <p>{programDescription}</p>
        </div>
        <StyledButton onClick={handleConnect}>Connect</StyledButton>
      </ContentContainer>
    </Container>
  );
};

const Container = styled.div`
  background: ${({ theme }) => theme.colors.primaryGrey};
  border: 1px solid ${({ theme }) => theme.colors.blueGrey[80]};
  border-radius: 6px;
  display: flex;
  gap: 16px;
  padding: 24px 16px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    align-items: center;
  }
`;

const ContentContainer = styled.div`
  color: ${({ theme }) => theme.colors.grey[30]};
  flex: 1;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    align-items: center;
    display: flex;
    gap: 16px;
    justify-content: space-between;
  }
`;

const StyledRewardsRibbon = styled(RewardsRibbon)`
  flex-shrink: 0;
`;

const Heading = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
`;

const StyledButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-top: 16px;
  }
`;
